import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { EDGE_PROFILES } from "@/lib/edgeProfiles";
import { Edge3DModal } from "@/components/site/Edge3DViewer";
import { useEdgeStones } from "@/components/site/StonePicker";

const finishOf = (f) => (/hon|leather|matte|suede|brush|satin/i.test(f || "") ? "honed" : "polished");

// "Edges in this stone" viewer. No inline preview lives on the page — the slab page's
// "Edge view" button opens this popup (via openToken), and shared ?edge= links land here.
export const EdgeOnSlab = ({ item, photoUrl, openToken = 0 }) => {
  const [params] = useSearchParams();
  const linked = EDGE_PROFILES.find((p) => p.slug === params.get("edge"));
  const [slug] = useState(linked ? linked.slug : "eased");
  const [full, setFull] = useState(Boolean(linked));
  const [picked, setPicked] = useState(null);
  useEffect(() => {
    if (openToken) setFull(true);
  }, [openToken]);
  const profile = EDGE_PROFILES.find((p) => p.slug === slug) || EDGE_PROFILES[0];
  const finish = finishOf(item.finish);
  const texture = item.edge_photo || item.photo;
  const stone = useMemo(
    () => ({
      key: item.key,
      name: item.color,
      photo: texture ? photoUrl(texture, 1600) : "",
      meta: "This slab",
    }),
    [item.key, item.color, texture, photoUrl],
  );
  const stones = useEdgeStones(full);
  const shareLink = (p, s, b) =>
    s.key === item.key
      ? `${window.location.origin}/inventory/${item.key}?edge=${p.slug}`
      : `${window.location.origin}/collections/material/edges?edge=${p.slug}&stone=${encodeURIComponent(
          s.key,
        )}${b ? `&vs=${b.slug}` : ""}`;

  if (!full) return null;
  return (
    <Edge3DModal
      profile={profile}
      stone={picked || stone}
      fallback={stone}
      stones={stones}
      onStone={setPicked}
      initialFinish={finish}
      shareLink={shareLink}
      onClose={() => setFull(false)}
    />
  );
};
